import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "disclaimer" }

import InfoIcon from '@/assets/InfoIcon.svg'


export default /*#__PURE__*/_defineComponent({
  __name: 'Disclaimer',
  props: {
    message: null
  },
  setup(__props: any) {

const props = __props as {
  message: string;
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(InfoIcon), { class: "info-icon" }),
    _createElementVNode("p", null, _toDisplayString(__props.message), 1)
  ]))
}
}

})